module.exports = function () { /* empty */ };



//////////////////
// WEBPACK FOOTER
// ./node_modules/_core-js@2.6.4@core-js/library/modules/_add-to-unscopables.js
// module id = 0O37
// module chunks = 0